import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

type PropsType = SVGComponentPropsType & {
  large?: boolean;
};

const defaultSize = 24;

const defaultLargeSize = 40;

export default ({ color = defaultIconColor, size = defaultSize, large = false, ...props }: PropsType) => {
  if (size === defaultSize && large) {
    size = defaultLargeSize;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={size}
      height={size}
      viewBox={`0 0 ${large ? defaultLargeSize : defaultSize} ${large ? defaultLargeSize : defaultSize}`}
      {...props}
    >
      {large ? (
        <path
          d="M23.5 14V9c0-.5523-.4477-1-1-1h-12v24h19V15c0-.5522-.4477-1-1-1h-5ZM14.5 20h11M14.5 24.0001h11"
          stroke={color}
          strokeWidth="2"
        />
      ) : (
        <g fillRule="nonzero" fill="none">
          <path d="M14 9V6a1 1 0 0 0-1-1H6h0v14h12v-9a1 1 0 0 0-1-1h-3 0z" stroke={color} strokeWidth="2" />
          <path fill={color} d="M15 13H9v-2h6zM15 16H9v-2h6z" />
        </g>
      )}
    </svg>
  );
};
